export interface AssigneeProps {
    userId: string
    firstname: string
    lastname: string
    nickname?: string
    role: string
}

export enum TypeReassignment {
    cumulative = 'cumulative',
    substitutive = 'substitutive',
}

export enum SizeReassignment {
    entire = 'entire',
    partial = 'partial',
}

export enum DelegateType {
    executor = 'executor',
    approver = 'approver',
}
export interface DelegateQuery {
    projectId: string
    storeId: string
    type: DelegateType
}
export interface StoreInfoAssignee {
    storeId: string
    delegateUserId?: string
    delegateRole?: string
    typeReassignment: TypeReassignment
}
export interface DelegatePayload {
    type: DelegateType
    storeInfoAssignees: StoreInfoAssignee[]
    jobIds?: string[]
    surveyIds?: string[]
    questionIds?: string[]
    reason?: string
}
export interface DelegateHistoryStep {
    id?: string
    reassignment: string // role or userId
    typeReassignment?: TypeReassignment
    date: number
}

export interface DelegateHistory {
    // communication project
    questions?: DelegateHistoryStep[]
    surveys?: DelegateHistoryStep[]
    jobs?: DelegateHistoryStep[]
    // photographic task
    data?: DelegateHistoryStep[]
}
